var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(this.contentTemplate !== '')?_c({
      name: 'dynamic-content',
      template: this.contentTemplate,
    },{tag:"component",staticClass:"main-component"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }